export default () => ({
    diInformations: {},
    diDocuments: {},
    diOrders: {}
});
